export type OktaIdpConfig = {
  readonly organization: string;
  readonly returnTo: string;
  readonly loginReturnTo: string;
  readonly redirectUri: string;
};

type OktaIdpConfigResult =
  | {
      readonly status: 'missing';
    }
  | {
      readonly status: 'ready';
      readonly config: OktaIdpConfig;
    };

const DEFAULT_RETURN_TO = '/';
const LOGIN_CALLBACK_PATH = '/login';

const getSafeReturnTo = (returnTo: string | null): string => {
  if (!returnTo || !returnTo.startsWith('/') || returnTo.startsWith('//')) {
    return DEFAULT_RETURN_TO;
  }

  return returnTo;
};

const getLoginReturnTo = (returnTo: string): string => {
  if (returnTo === DEFAULT_RETURN_TO) {
    return LOGIN_CALLBACK_PATH;
  }

  return `${LOGIN_CALLBACK_PATH}?from=${encodeURIComponent(returnTo)}`;
};

export const resolveOktaIdpConfig = (
  organizationParam: string | null,
  returnToParam: string | null,
  origin = window.location.origin,
): OktaIdpConfigResult => {
  const organizationFromUrl = organizationParam?.trim();
  if (!organizationFromUrl) {
    return { status: 'missing' };
  }

  const organization = organizationFromUrl;

  const returnTo = getSafeReturnTo(returnToParam);

  return {
    status: 'ready',
    config: {
      organization,
      returnTo,
      loginReturnTo: getLoginReturnTo(returnTo),
      redirectUri: new URL(LOGIN_CALLBACK_PATH, origin).toString(),
    },
  };
};
